import React from 'react';
import HowItWorksPageContent from "../../components/sections/front/sections/HowItWorksPageContent";
import Pricing from "../../components/sections/front/sections/Pricing";
import HomeFaq from '../../components/sections/front/sections/HomeFaq';

const HowItWorks = () => {
  return (
    <>
      <HowItWorksPageContent />
      <HomeFaq />
      <Pricing/>
    </>
  );
};

export default HowItWorks;